// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__24dzW","title":"Images90_title__2JzFt","images":"Images90_images__1CItS"};